module.exports = __webpack_public_path__ + "static/media/Orinocco96.3c083cc2.jpg";